<script setup>
const props = defineProps({
  dice: {
    type: Array,
  },
  color:{
    type: String,
    default: "W" 
  },
  player_color: {
    type: String,
    default: "W"
  }
})
</script>

<template>
    <div class="dice-tray" :class="[color, color === player_color ? 'player' : 'opponent'] ">
        <ul class="dice" v-for="d in dice" :class="{inactive: !d.active}">
            <!-- ROW 1 -->
            <li :class="{pip: '23456'.includes(d.pips)}"/>
            <li :class="{pip: ''.includes(d.pips)}"/>
            <li :class="{pip: '456'.includes(d.pips)}"/>
            <!-- ROW 2 -->
            <li :class="{pip: '6'.includes(d.pips)}"/>
            <li :class="{pip: '135'.includes(d.pips)}"/>
            <li :class="{pip: '6'.includes(d.pips)}"/>
            <!-- ROW 3 -->
            <li :class="{pip: '456'.includes(d.pips)}"/>
            <li :class="{pip: ''.includes(d.pips)}"/>
            <li :class="{pip: '23456'.includes(d.pips)}"/>
        </ul>
    </div>
</template>

<style scoped>
.dice-tray{
    display:inline-flex;
    flex-direction:row;
    position:absolute;
    top: 50%;
    height: 6%;
    transform: translate(-50%, -50%);
}

.player{
    left:75%;
}
.opponent{
    left:25%;
}

.dice{
    display:grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-auto-flow: dense;
    grid-gap: 0.2em;

    height: 100%;

    aspect-ratio: 1/1;
    background-color: blue;

    margin:0;
    margin-right:0.4em;
    padding:0.3em;
    box-sizing: content-box;
    border-radius:10%;
    border: 0.2rem solid;
    border: 0.5cqw solid;
}
.dice.inactive{ /* TODO better to mix with the 'other' color */
    filter: brightness(150%);
}
.W > .dice{
    background-color:var(--dice-w-color);
    color:var(--dice-pip-w-color);
    border-color:var(--dice-border-w-color);
}
.B > .dice{
    background-color:var(--dice-b-color);
    color:var(--dice-pip-b-color);
    border-color:var(--dice-border-b-color);
}

li{
    list-style-type: none;
    padding:0;
    margin: 0;
    aspect-ratio: 1/1;
    display:inline-block;
    position:relative;
    border-radius: 100%;
}

.W > .dice > .pip{
    background-color:var(--dice-pip-w-color);
}
.B > .dice> .pip{
    background-color:var(--dice-pip-b-color);
}

</style>
